<div class="ui-g loyalty-cluster-type" *ngIf="translations">
  <div class="ui-g-12">

    <app-kontable #table
                  title = "{{ 'cluster_type.cluster_type_title' | translate }}"
                  [columns] = "['id','code','description']"
                  [titles] = "['common.id', 'cluster_type.code','cluster_type.description']"                  
                  [showInfoButton]="false"
                  [showRecoverButton]="false"
                  [showGlobalFilter]="false"
                  [showDetailsButton]="false"
                  [showAddButton]="true"
                  [showEditButton]="true"
                  [source]="listClusterType"                  
                  (onAdd)="addNew($event)"
                  (onEdit)="edit($event)"
                  (onRemove)="remove($event)">
             
    </app-kontable>

  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-cluster-type/loyalty-cluster-type.component.html